var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.83 1.4c6.084 0 11.034 4.949 11.034 11.033s-4.95 11.033-11.033 11.033c-1.823 0-3.617-.457-5.226-1.328l-.342-.193-4.958 1.495a.623.623 0 01-.773-.793l.04-.099 2.107-3.972a10.93 10.93 0 01-1.881-6.143C1.798 6.349 6.748 1.4 12.83 1.4zm0 1.25c-5.393 0-9.782 4.388-9.782 9.783a9.7 9.7 0 001.868 5.731c.12.166.15.377.086.567l-.04.093-1.583 2.987 3.789-1.143a.62.62 0 01.51.069 9.764 9.764 0 005.153 1.479c5.395 0 9.783-4.389 9.783-9.783 0-5.395-4.388-9.783-9.783-9.783zm.803 7.61v7.28h1.945a.625.625 0 01.093 1.242l-.093.007h-5.14a.625.625 0 01-.092-1.243l.092-.007h1.945V11.51h-1.945a.625.625 0 01-.092-1.243l.092-.007h3.195zm-.802-4.503a1.129 1.129 0 110 2.26 1.129 1.129 0 010-2.261z",
    fill: "#333",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "4e530f11f7466bb53009a8fca1ae36ae.svg";
export { SvgIconFaq as ReactComponent };